const Keyboard = window.SimpleKeyboard.default;

document.addEventListener('DOMContentLoaded', function() {
	if($('.form-section-personalize').length > 0) {
		$('.form-section-personalize').each(function(index) {
			let target = index + 1;
			target = 'simple-keyboard' + target;
			keyboardInit(target);
		});
	} else {
		keyboardInit('simple-keyboard');
	}
});

function keyboardInit(target) {
	const myKeyboard = new Keyboard(target, {
		onInit: keyboard => onInit(keyboard),
		onChange: input => onChange(input),
		onKeyPress: button => onKeyPress(button),
		tabCharOnTab: false,
		layoutName: "default",
		display: {
			'{bksp}': '1字削除',
			'{shift}': 'Shift',
			'{space}': '半角スペース',
			'{英字}': '英字',
			'{記号}': '記号',
		},
		layout: {
			'default': [
			'` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
			'q w e r t y u i o p [ ] \\',
			'a s d f g h j k l ; \'',
			'{shift} z x c v b n m , . /',
			'{space}'
			],
			'shift': [
			'~ ! @ # $ % ^ & * ( ) _ + {bksp}',
			'Q W E R T Y U I O P { } |',
			'A S D F G H J K L : "',
			'{shift} Z X C V B N M < > ?',
			'{space}'
			]
			// '記号': [
			// 	'❤ ♥ ❥ ❦ ♤ ♠ ♬ ♫ ♪ ♫ ♪ ☺ ☻ ☹ ✺',
			// 	'☂ ☁ ☼ ❆ ❅ ☃ ✈ ☑ ☒ ☎ ✉ ♀ ♂ ✔ ✖',
			// 	'♻ ♨ ✇ ☮ ☯ ☠ ⚖ ☾ ☪ ☄ ❂ ✵ ✌ ☛ ☚',
			// 	'☝ ☟ ☞ ☜ ✍ ☉ ☍ ✏ ✎ ✐ ✂ ✁ ✃ ✄ ☊',
			// 	'☋ ☌ ♁ ☇ ☈ ☡ ✇ ☢ ☣ ⚣ ღ ☤ ⚕ ⚚ †',
			// 	'♈ ♉ ♊ ♋ ♌ ♍ ♎ ♏ ♐ ♑ ♒ ♓ ♅ ♇ ♆',
			// 	'♛ ♕ ♝ ♗ ♟ ♙ ♚ ♔ ♜ ♖ ♞ ♘ ⚘ ⚛ ⚜',
			// 	'☸ ☆ ★ ✩ ✪ ✫ ✬ ✭ ✮ ✯ ✰ ✧ ❁ ❀ ✿',
			// 	'✾ ✽ ✣ ❉ ❃ ⎈ → ⇒ ⟹ ⇨ 䡗 ➩ ➪ ➫ ➬',
			// 	'➭ ➮ ➯ ➲ ➳ ➵ ➸ ➻ ➺ ➽ ➹ ➷ ↶ ↷ ✆',
			// 	'{英字} ⌘ ⎋ ⏎ ⏏ ⎌ ⍟ ツ {bksp}'
			// ]
		},
		maxLength: 23
	});

	function onInit(keyboard) {
		// default set
		if($('.form-section-personalize').length > 0) {
			console.log("simple-keyboard initialized", keyboard)
			let target = keyboard.currentInstanceName;
			target = target.replace('simpleKeyboard', 'simple-keyboard');
			target = '.' + target;
			target_keyboard = $(target).prev().find(".keyboard");
			input = target_keyboard.val();
			keyboard.setInput(input);
			var $counterElement = target_keyboard.parent().siblings('.input-count');
			if($counterElement.length == 0)
				$counterElement = target_keyboard.parents('.form-bar').find('.input-count');
			var maxChars = parseInt($counterElement.data('maxlength'));
			$counterElement.html(maxChars - input.length);
		}
	}

	function onChange(input) {
		if($('.form-section-personalize').length > 0) {
			let target = myKeyboard.currentInstanceName;
			target = target.replace('simpleKeyboard', 'simple-keyboard');
			target = '.' + target;
			target_keyboard = $(target).prev().find(".keyboard");
			target_keyboard.val(input);
			var $counterElement = target_keyboard.parent().siblings('.input-count');
			if($counterElement.length == 0)
				$counterElement = target_keyboard.parents('.form-bar').find('.input-count');
			var maxChars = parseInt($counterElement.data('maxlength'));
			$counterElement.html(maxChars - input.length);
			// console.log("Input changed", input);
		} else {
			document.querySelector(".form-controls .keyboard").value = input;
			var $counterElement = $(".form-controls .keyboard").parent().siblings('.input-count');
			if($counterElement.length == 0)
				$counterElement = $(".form-controls .keyboard").parents('.form-bar').find('.input-count');
			var maxChars = parseInt($counterElement.data('maxlength'));
			$counterElement.html(maxChars - input.length);
			// console.log("Input changed", input);
		}
	}

	function onKeyPress(button) {
		// console.log("Button pressed", button);
		let currentLayout = myKeyboard.options.layoutName;

		if (button === "{shift}") {
			let shiftToggle = currentLayout === "default" ? "shift" : "default";
			myKeyboard.setOptions({
				layoutName: shiftToggle
			});
		}

		// if (button === "{記号}") {
		// 	myKeyboard.setOptions({
		// 		layoutName: '記号'
		// 	});
		// }

		if (button === "{英字}") {
			myKeyboard.setOptions({
				layoutName: 'default'
			});
		};
	}

}
